<template>
  <div class="form-container">
    <!-- 电脑端使用 Element UI 表单 -->
    <section v-if="isDesktop" style="padding:0 5%;">
      <el-form
        ref="form"
        label-position="top"
        status-icon
        :model="form"
        :rules="rules"
        label-width="100px"
        style="width:100%;"
      >
        
        <el-form-item label="字典名称" prop="name" required>
          <el-input v-model="form.name" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="场景说明" prop="command" required>
          <el-input type="textarea" v-model="form.command" placeholder="请输入场景说明" :rows="5"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="submit('form')" :plain="true">立即修改</el-button>
        </el-form-item>
      </el-form>
    </section>

    <!-- 手机端使用 Vant 表单 -->
    <div v-else class="mobile-form-container">
      <div class="mobile-form-content">
        <van-form ref="mobileForm" :model="form" :rules="rules" @submit="onMobileSubmit">
          <!-- 字典名称 -->
          <van-cell-group inset>
            <van-field
              v-model="form.name"
              name="name"
              input-align="right"
              label="字典名称"
              placeholder="请输入字典名称"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 场景说明 -->
            <van-field
              v-model="form.command"
              name="command"
              input-align="right"
              label="场景说明"
              placeholder="请输入场景说明"
              type="textarea"
              rows="5"
              :validate-trigger="['onChange', 'onBlur']"
            />
          </van-cell-group>
        </van-form>
      </div>
      
      <!-- 手机端固定底部按钮 -->
      <div class="mobile-form-actions">
        <van-button type="default" block @click="close">取消</van-button>
        <van-button type="primary" block @click="onMobileSubmit">立即修改</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  let _this;
  import {editHallData,getHallListById} from "@/api/dictionaries.js";
  import { Field, Cell, CellGroup, Form, Button, Toast } from 'vant';
  
  export default {
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Form.name]: Form,
      [Button.name]: Button
    },
    props: {
      id: Number
    },
    data() {
      return {
        isDesktop: true,
        form: {},
        templeList:[],
        rules: {
          name: [
            {required: true, message: "请输入字典名称", trigger: "blur"},
          ],
          command: [
            {required: true, message: "请输入场景说明", trigger: "blur"},
          ],
        },
        
      };
    },

    computed: {},

    mounted() {
      _this = this;
      _this.init();
      this.checkScreenSize();
      window.addEventListener('resize', this.handleResize);
    },
    
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      // 检查屏幕大小
      checkScreenSize() {
        this.isDesktop = window.innerWidth > 768;
      },
      
      // 处理窗口大小变化
      handleResize() {
        this.checkScreenSize();
      },
      
      // 初始化数据
      init() {
        getHallListById(this.id).then(res=>{
          if(res.code === 200){
            this.form = res.data
          }
        })
      },
      
      close() {
        // 初始化表单
        this.initForm();
        _this.$emit("close");
      },
      
      // 初始化表单数据
      initForm() {
        this.form = {};
      },
      
      // 电脑端提交
      submit(form) {
        console.log(this.form)
        this.$refs[form].validate(valid => {
          if (valid) {
            editHallData(this.id,_this.form).then(res => {
              if (res.code === 200) {
                setTimeout(() => {
                  _this.$emit("success");
                  _this.$emit("close");
                }, 1000);
              }
            })
          } else {
            console.log("error submit!!");
            return false;
          }
        })
      },
      
      // 手机端提交
      onMobileSubmit() {
        this.$refs.mobileForm.validate().then(() => {
          // 验证通过，提交数据
          editHallData(this.id, this.form).then(res => {
            if (res.code === 200) {
              Toast({
                message: '修改成功',
                type: 'success',
                duration: 1500
              });
              setTimeout(() => {
                this.$emit("success");
                this.$emit("close");
              }, 1500);
            } else {
              Toast({
                message: res.message || '修改失败',
                type: 'fail',
                duration: 1500
              });
            }
          }).catch(error => {
            Toast({
              message: '网络错误，请稍后重试',
              type: 'fail',
              duration: 1500
            });
          });
        }).catch(errorInfo => {
          // 验证失败
          console.log('表单验证失败：', errorInfo);
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .form-container {
    width: 100%;
    height: 100%;
  }

  // 电脑端样式
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    text-align: left !important;
  }

  // 手机端样式
  .mobile-form-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .mobile-form-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 45px;
  }

  .mobile-form-actions {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
  }

  .mobile-form-actions .van-button {
    flex: 1;
    height: 44px;
    font-size: 16px;
  }
</style>
